import { DialogTemplate } from "src/app/_models/body";
import { InputFieldType } from "src/app/common/constants";

export const AIAgentGroupTemplate = (editMode, aiBuddyAssets): DialogTemplate => {
    return {
        dialogTitle: editMode ? 'Edit AI Agent Group' : 'Add AI Agent Group',
        dialogFields: [
            {
                key: 'name',
                label: 'Name',
                type: InputFieldType.Text,
                size: 12,
                required: true
            },
            {
                key: 'maxMinutes',
                label: 'Max Minutes',
                type: InputFieldType.Number,
                size: 12,
                required: true,
                errorKey: 'range'
            },
            {
                key: 'agentKinds',
                label: 'Agent Kinds',
                type: InputFieldType.Selector,
                mode: 'multiple',
                size: 24,
                options: aiBuddyAssets,
                required: true
            }

        ]
    }

}